$(document).ready(function() {
  
   	
	  $(document).on('click', '.fixed__hamburger', openMenu);
    $(document).on('click', '.main-menu__link', closeMenu);
    $(document).on('click', '.main-menu__close', closeMenu);

    function openMenu(event) {
        $('.main-menu').addClass('main-menu--active');
      }
    
      function closeMenu(event) {
        $('.main-menu').removeClass('main-menu--active');
      }

    $('.brands__carousel').owlCarousel({
        loop: true,
        margin: 0,
        nav: false,
        dots: false,
        navText: [],
        items: 5,
        autoplay: true,
        smartSpeed: 2000,
        autoplayTimeout: 2000,
        
        responsive:{
            0:{
                items:1
            },
            480:{
                items:2
            },
            768:{
                items:3
            },
            980:{
                items:5
            }
        }
        })

        $('.history__slides').owlCarousel({
          loop: true,
          margin: 0,
          nav: true,
          dots: true,
          navText: [],
          items: 1,
          autoplay: true,
          smartSpeed: 500,
          autoplayTimeout: 5000,
          
          responsive:{
              0:{
                  items:1
              },
              480:{
                  items:1
              },
              768:{
                  items:1
              },
              980:{
                  items:1
              }
          }
          })

          /* Smooth scroll */
    $("[data-scroll]").on("click", function(event) {
      event.preventDefault();

      var $this = $(this),
          blockId = $this.data('scroll'),
          blockOffset = $(blockId).offset().top;

      $("html, body").animate({
          scrollTop:  blockOffset
      }, 
      500);
  });
});


window.onscroll = function () {
       scrollFunction()
     };

     function scrollFunction() {
       if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
         document.getElementById("movetop").style.display = "block";
       } else {
         document.getElementById("movetop").style.display = "none";
       }
     }

     let ok = false; 

window.addEventListener('scroll', function() {
    if (ok === false) {
        ok = true;    
        setTimeout(() => {                    
            let script = document.createElement('script');
            script.src = 'https://api-maps.yandex.ru/services/constructor/1.0/js/?um=constructor%3Aa8f0893b410ab50123493b889a1d1a47640f8f2af65fc3ddab23659bacdf0d3d&amp;width=100%25&amp;height=470&amp;lang=ru_RU&amp;scroll=false';
            document.getElementById('yamap').replaceWith(script);                        
        }, 3000)    
    }
});
